import { Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

type StylesType = {
  noBorder: boolean
}

const useStyles = makeStyles<Theme, StylesType>(theme => ({
  menuTitleArea: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '0.5rem'
  },

  menuTitle: {
    fontSize: theme.size.base
  },

  menuClose: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },

  menuFormControl: {
    maxHeight: '50vh',
    overflowY: 'auto'
  },

  root: {
    '& .MuiAccordion-root.Mui-expanded': {
      margin: '0 !important'
    },

    '& .MuiAccordion-root': {
      borderTopColor: ({ noBorder }) => (noBorder ? 'transparent' : 'none')
    }
  },

  control: {
    '& .MuiSvgIcon-fontSizeSmall': {
      fontSize: theme.size.lg
    }
  },

  radio: {
    marginTop: '1px'
  },

  controlLabel: {
    '& .MuiFormControlLabel-label': {
      fontSize: theme.size.sm,
      userSelect: 'none'
    }
  },

  controlLabelBold: {
    '& .MuiFormControlLabel-label': {
      fontSize: theme.size.sm,
      userSelect: 'none'
    }
  }
}))

export default useStyles
